import { render, staticRenderFns } from "./IconSvgPin.vue?vue&type=template&id=30015794&"
import script from "./IconSvgPin.vue?vue&type=script&lang=js&"
export * from "./IconSvgPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports